import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";

const BankDetailMain = () => {
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={"Name"} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={"UniqueCode"} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput title={"CreatedDate"} fieldName={"createdDate"} />
        </Col>
      </Row>
    </>
  );
};

export default BankDetailMain;
